import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyHeartbeats: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-heartbeats", jiraSpaEntry: "async-jira-eoc-heartbeats" */ '@jira/eoc__heartbeats/src/index.tsx'
		),
);

export const HeartbeatsComponent = (): React.JSX.Element => (
	<LazyPage Page={LazyHeartbeats} pageId="async-jira-eoc-heartbeats" shouldShowSpinner={false} />
);
